export default __webpack_public_path__ + "static/media/shopping cart.fb9c6d2b.png";